import { Redirect, withRouter } from 'react-router-dom';
import { useAuthState } from '../../contexts/auth-context';
import React from 'react';

const Home = () => {
  const { auth } = useAuthState();
  return auth.isAuthenticated ? (
    <Redirect to="/customers/all-tenants" />
  ) : (
    <Redirect to="/login" />
  );
};

export default withRouter(Home);
